<template>
 <div class="testimonial__wrapper u-row u-column--sm u-bg-grey-light u-pad-x-1of12 u-pad-y-xl u-pad-y-lg--sm">

  <div class="u-w3of10 u-pad-r-md u-pad-r-0--sm u-w10of10--sm u-center">
    <div class="u-marg-b-md">
      <div class="u-box-1by1 u-round u-overflow-hidden u-w5of10 u-inline-block">
        <app-image :width="400" :height="400" :id="data.picture[0].id" :src="data.picture[0].url" class="u-fit-cover u-wrapper-panel" />
      </div>
    </div>
    <p class="t-text--xsmall u-blue u-marg-b-sm">{{data.fullName}}</p>
    <p class="t-text--xsmall u-grey">{{data.role}}</p>
  </div>
  <div class="u-w5of10 u-w10of10--sm u-relative u-flex u-middle">
    <div class="testimonial__quote testimonial__quote--left" v-if="!$device.isTablet">&ldquo;</div>
    <p class="u-left u-middle t-text u-pad-y-md--sm u-white-space">{{data.text}}</p>
    <div class="testimonial__quote testimonial__quote--right" v-if="!$device.isTablet">&rdquo;</div>
  </div>

  <slot></slot>

</div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
  },
}
</script>

<style lang="stylus">
    
</style>